// frontend/src/components/ScrollToTopButton.js

// Import React and hooks for state and effect
import React, { useEffect, useState } from "react";
// Import FontAwesome icons
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Functional component for a "Scroll to Top" button
const ScrollToTopButton = () => {
  // State to track if button should be visible
  const [visible, setVisible] = useState(false);

  // useEffect to handle scroll event listener
  useEffect(() => {
    // Function to check scroll position
    const handleScroll = () => setVisible(window.scrollY > 300); // Show button after scrolling 300px

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove listener on component unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []); // Empty dependency array ensures this runs once on mount

  // Function to scroll smoothly to top
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    // Button element
    <button
      onClick={scrollToTop} // Call scrollToTop on click
      className={`
        fixed bottom-6 right-6 // Position fixed at bottom-right corner
        bg-gray-600 hover:bg-gray-700 // Background color and hover effect
        text-white p-3 rounded-full shadow-lg // Padding, rounded, and shadow for styling
        z-50 // Ensure button appears above most content
        transition-opacity duration-500 // Smooth fade in/out
        ${visible ? "opacity-100" : "opacity-0 pointer-events-none"} // Show/hide button based on state
      `}
      aria-label="Scroll to top" // Accessibility label
    >
      {/* FontAwesome up arrow icon */}
      <FontAwesomeIcon icon={faArrowUp} />
    </button>
  );
};

// Export component for use in other parts of the app
export default ScrollToTopButton;
